export const colors = {
  dark: '#1E1E1E',
  light: '#fff',
  cream: '#FBF6E8',
  darkGrey: '#626262',
  midGrey: '#BCBCBC',
  lightGrey: '#EEEEEE',
  yellow: '#F2BF28',
}
